export default {
    Menu: 'Menu',
    Add: 'Dodaj',
    Modify: 'Edytuj',
    Delete: 'Usuń',
    Scale: 'Zmień rozmiar',
    Color: 'Kolor',
    Materials: 'Materiały',
    Mesh: 'Siatka',
    Size: 'Rozmiar',
    Details: 'Szczegóły',
    Quantity: 'Ilość',
    AddToCart: 'Dodaj do koszyka',
    AddToCartTitle: 'Dodaj do koszyka',
    Cart: 'Koszyk',
    Total: 'Razem',
    Subtotal: 'Suma częściowa',
    Shipping: 'Dostawa',
    Shape: 'Kształt',
    PickShape: 'Wybierz kształt do dodania na kanwę',
    ShapeAdded: 'Dodano kształt. Kliknij inny, aby go zastąpić.',
    Clipart: 'Ilustracja',
    PickClipart: 'Wybierz ilustrację do dodania na kanwę',
    ClipartAdded: 'Dodano ilustrację. Kliknij inną, aby ją zastąpić.',
    SearchClipart: 'Szukaj ilustracji…',
    NoClipartFound: 'Nie znaleziono ilustracji',
    Cliparts: 'Clipart',
    Illustration: 'Ilustracja',
    AiImage: 'Obraz AI',
    AiImageIntro: 'Opisz, czego chcesz, wybierz format i otrzymaj 2 propozycje.',
    AiImageFormat: 'Format',
    AiFormatSquare: 'Kwadrat',
    AiFormatPortrait: 'Pionowy',
    AiFormatLandscape: 'Poziomy',
    AiImagePlaceholder: 'Np.: stylizowany rudy lis, płaski styl, przezroczyste tło…',
    AiGenerate: 'Generuj',
    AiGenerating: 'Generowanie…',
    AiPickResult: 'Wybierz propozycję',
    AiImageAdded: 'Dodano obraz na kanwę',
    AiImageError: 'Nie udało się wygenerować obrazu',
    AiNoResult: 'Nie wygenerowano żadnego obrazu',
    AiImageNotInPlan: 'Generowanie obrazów AI nie jest zawarte w Twoim planie. Aktywuj opcję, aby z niej korzystać.',
    SearchIllustration: 'Szukaj ilustracji…',
    NoIllustrationFound: 'Nie znaleziono ilustracji',
    IllustrationIntro: 'Wyszukaj ilustracje wektorowe do dodania na kanwę.',
    IllustrationError: 'Nie udało się wyszukać ilustracji',
    IllustrationNotVector: 'Ten wynik nie jest użytecznym wektorem',
    Texts: 'Teksty',
    Images: 'Obrazy',
    Colors: 'Kolory',
    ThemeEditDesc: 'Edytuj teksty, obrazy i kolory motywu.',
    ThemeNotFound: 'Nie znaleziono motywu.',
    ThemeNoEditable: 'Ten motyw nie zawiera edytowalnych elementów.',
    Helpers: 'Linijki, prowadnice i siatka',
    Rulers: 'Linijki',
    RulersHint: 'Podziałka w pikselach',
    Guides: 'Prowadnice',
    GuidesHint: 'Znaczniki przy 25 / 50 / 75 %',
    GridHint: 'Siatka nakładana',
    Snapping: 'Przyciąganie',
    SnappingHint: 'Wyrównuje do środka / siatki / innych obiektów',
    LeaveConfirm: 'Czy na pewno chcesz utracić zmiany?',
    Products: 'Produkty',
    Customization: 'Personalizacja',
    BackToCustomizationType: 'Typ personalizacji',
    SaveNoChanges: 'Brak zmian do zapisania',
    ChooseCategory: 'Wybierz kategorię',
    SelectProduct: 'Wybierz produkt',
    Loading: 'Ładowanie',
    ProofLogoTooLarge: 'Logo za duże (maksymalnie 500 KB).',
    ProofLogoInvalidType: 'Nieobsługiwany format obrazu.',
    ProofLogoImported: 'Logo zaimportowane.',
    ProofLogoImportFailed: 'Import logo nie powiódł się.',
    YouHaveProjects: 'Masz {count} projekt(y) w toku',
    ResumeProject: 'Wznów projekt',
    ResumeProjectHint: 'Kontynuuj tam, gdzie skończyłeś.',
    YourProjects: 'Twoje projekty w toku',
    OpenProject: 'Otwórz ten projekt',
    NoProjects: 'Brak projektów w toku.',
    AppUpdating: 'Aktualizowanie aplikacji…',
    DraftRestored: 'Przywrócono szkic',
    SaveExpiredTitle: 'Zapis wygasł',
    SaveExpiredMessage: 'Ten zapis wygasł lub nie jest już dostępny.',
    Continue: 'Kontynuuj',
    PhotoFramePickShape: 'Wybierz ramkę',
    PhotoFramePlacePhoto: 'Umieść i dopasuj zdjęcie',
    PhotoFrameChangePhoto: 'Zmień zdjęcie',
    PhotoFrameDropTitle: 'Upuść zdjęcie tutaj',
    PhotoFrameDropSub: 'lub kliknij, aby przesłać',
    Rotation: 'Obrót',
    Reset: 'Resetuj',
    ProofLogoTitle: 'Logo wydruku próbnego',
    ProofLogoUseSite: 'Zachowaj logo {site}',
    ProofLogoUseMine: 'Z moim własnym logo',
    ProofLogoUseMineDesc: 'Tylko na wydruku próbnym, nie na plikach do druku.',
    ProofLogoNone: 'Bez logo',
    ProofLogoDropTitle: 'Prześlij swoje logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Weryfikacja zamówienia',
    LoadingStepScreenshots: 'Generowanie podglądów',
    LoadingStepPrintFile: 'Generowanie plików do druku',
    LoadingStepUpload: 'Wysyłanie na serwer',
    LoadingStepSave: 'Zapisywanie konfiguracji',
    LoadingGraduation: 'Wczytywanie skali',
    OptimizingImage: 'Optymalizacja obrazu',
    LoadingScene: 'Ładowanie sceny',
    LoadingStepZip: 'Tworzenie pliku zip',
    LoadingProduct: 'Ładowanie produktu',
    Category: 'Kategoria',
    Product: 'Produkt',
    Summary: 'Podsumowanie',
    Zone: 'Strefa',
    SelectZone: 'Wybierz strefę',
    SelectAZone: 'Wybierz strefę',
    Undo: 'Cofnij',
    Redo: 'Ponów',
    Recenter: 'Wyśrodkuj widok',
    HelpersIntro: 'Krawędzie stref, siatka, linijki i prowadnice na kanwie 2D.',
    ShowZoneBordersHint: 'Ramki stref na głównej kanwie',
    Save: 'Zapisz',
    Saving: 'Zapisywanie',
    Grid: 'Siatka',
    SwitchTo3D: 'Przełącz na 3D',
    PrintZone: 'Obszar druku',
    ViewModeSwitch: 'Tryb wyświetlania',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Podwójny',
    ShowZoneBorders: 'Pokaż kontury stref',
    ShowZoneBordersHelp: 'Pokazuje/ukrywa przerywany kontur i etykietę stref na kanwie 2D.',
    ManageElements: 'Zarządzaj elementami',
    StartWithTheme: 'Zacznij od motywu',
    Customize: 'Personalizuj',
    FromThemeLibrary: 'Z naszej biblioteki motywów',
    StartFromScratch: 'Zacznij od zera',
    Or: 'lub',
    PreviousCreations: 'Poprzednie projekty',
    WithModel: 'Z szablonem',
    Search: 'Szukaj',
    SubCategory: 'Podkategoria',
    Next: 'Dalej',
    Previous: 'Wstecz',
    Validate: 'Zatwierdź',
    DownloadMyProject: 'Pobierz mój projekt',
    EditThemeColors: 'Edytuj kolory elementów',
    AddPattern: 'Dodaj tło',
    EditGraduation: 'Edytuj gradient',
    Pattern: 'Tło',
    PatternHint: 'Wzór jest powtarzany na całym obszarze personalizacji. Jego kolory można dostosować.',
    SearchTheme: 'Szukaj motywu (tytuł lub tag)',
    Theme: 'Motyw',
    Graduation: 'Gradient',
    Graduation_s: 'Gradient(y)',
    ErrorOccurred: 'Wystąpił błąd.',
    ReloadPage: 'Odśwież stronę.',
    LoadingCategories: 'Ładowanie kategorii',
    ShowAll: 'Pokaż wszystko',
    Categories: 'Kategorie',
    ComingSoon: 'Wkrótce',
    DropImageHere: 'Przeciągnij tutaj obraz',
    ReleaseToImport: 'Puść, aby zaimportować',
    OrClickToBrowse: 'lub kliknij, aby przeglądać',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Ta metoda druku działa z określonymi kolorami. Zalecamy pliki wektorowe dla optymalnego efektu.',
    SearchInPhotoGallery: 'Szukaj w naszej galerii zdjęć',
    QrCode: 'Kod QR',
    QrCodeContent: 'Treść (URL, tekst, e-mail…)',
    QrCodePlaceholder: 'https://przyklad.com',
    QrCodeForeground: 'Kolor QR',
    QrCodeBackground: 'Tło',
    QrCodeTransparentBg: 'Przezroczyste tło',
    QrCodeErrorLevel: 'Tolerancja błędów',
    QrCodeErrorL: '7 % (niska gęstość)',
    QrCodeErrorM: '15 % (standard)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (wysoka)',
    QrCodeEmptyPreview: 'Wpisz treść, aby zobaczyć podgląd',
    QrCodeRequired: 'Treść kodu QR jest wymagana.',
    QrCodeInvalidUrl: 'Wpisz prawidłowy adres URL kodu QR (http:// lub https://).',
    QrCodeAdd: 'Dodaj kod QR',
    QrCodeEditOnlyColors: 'Po utworzeniu kodu QR można zmienić tylko kolory. Aby zmienić treść, usuń go i utwórz nowy.',
    ImageQualityGood: 'Dobra rozdzielczość',
    ImageQualityMedium: 'Średnia rozdzielczość',
    ImageQualityLow: 'Niska rozdzielczość – powiększ obraz lub zmniejsz go na kanwie',
    LowQualityAlertTitle: 'Uwaga',
    LowQualityAlertMessage:
        'Twój projekt zawiera obrazy niskiej jakości lub zbyt powiększone względem oryginalnej rozdzielczości. Popraw projekt albo zaakceptuj ryzyko pikselizacji przy druku.',
    LowQualityAlertHint: 'Próg niskiej rozdzielczości:',
    LowQualityAcceptRisk: 'Akceptuję ryzyko pikselizacji moich obrazów niskiej jakości',
    Preview: 'Podgląd',
    Bold: 'Pogrubienie',
    Italic: 'Kursywa',
    Underline: 'Podkreślenie',
    FontSize: 'Rozmiar',
    SelectFont: 'Wybierz czcionkę',
    UploadFont: 'Prześlij moją czcionkę',
    UploadFontHint: 'TTF lub OTF · maks. 5 MB',
    CustomFontBadge: 'własna',
    CustomFontImported: 'Zaimportowano czcionkę.',
    CustomFontFormatError: 'Nieobsługiwany format (tylko TTF lub OTF).',
    CustomFontTooLarge: 'Czcionka za duża (maksymalnie 5 MB).',
    CustomFontImportFailed: 'Import czcionki nie powiódł się.',
    CustomFontRemoved: 'Czcionka usunięta.',
    RecentFonts: 'Ostatnie',
    Clear: 'Wyczyść',
    TextColor: 'Kolor tekstu',
    TextOutline: 'Kontur',
    AddOutline: 'Dodaj kontur',
    RemoveOutline: 'Usuń kontur',
    PickColor: 'Wybierz kolor',
    PickThemeCategory: 'Wybierz kategorię, aby przeglądać motywy',
    NoThemeInCategory: 'Brak motywu w tej kategorii',
    ThemePreviewLabel: 'Podgląd motywu',
    PickAnotherTheme: 'Wybierz inny motyw',
    Keep: 'Zachowaj',
    LoadingThemes: 'Ładowanie motywów',
    LoadingPatterns: 'Ładowanie teł',
    EditableThemeColors: 'Edytowalne kolory elementów',
    PickAColor: 'Wybierz kolor',
    SelectALayout: 'Wybierz szablon',
    CreateLayer: 'Utwórz element',
    LastDownloads: 'Ostatnie pobrania',
    Cancel: 'Anuluj',
    Back: 'Wstecz',
    BackToProvider: 'Powrót do {provider}',
    LayerNotFound: 'Nie znaleziono elementu',
    ChangeImage: 'Zmień obraz',
    ChangePattern: 'Zmień tło',
    Resize: 'Zmień rozmiar',
    RemoveBackground: 'Usuń tło',
    Processing: 'Przetwarzanie…',
    AddFilter: 'Dodaj filtr',
    PhotoCredit: 'Zdjęcie autorstwa {author} na {provider}',
    PhotoBy: 'Zdjęcie autorstwa',
    On: 'na',
    LinkRedirectionWarning: 'Ten link przekieruje Cię na tę stronę',
    LoadMore: 'Załaduj więcej',
    EditLayer: 'Edytuj element',
    Import: 'Importuj',
    FromYourDevice: 'Z Twojego urządzenia',
    FromImageGallery: 'Z galerii obrazów',
    NoGraduationsAvailable: 'Brak dostępnych gradientów',
    Confirm: 'Potwierdź',
    CustomizeProduct: 'Spersonalizuj swój produkt',
    WriteYourText: 'Wpisz tutaj swój tekst',
    Text: 'Tekst',
    Image: 'Obraz',
    DesignSummary: 'Podsumowanie Twojego projektu',
    AddOptions: 'Dodaj opcje',
    TermsOfSale: 'Ogólne warunki sprzedaży',
    TOSMessage:
        'Oświadczam, że mój projekt jest zgodny z [Ogólnymi warunkami sprzedaży](#), a w szczególności z artykułem 8 - Własność intelektualna',
    IValidateMyCreation: 'Zatwierdzam mój projekt',
    FunctionalityNotAvailable: 'Funkcja niedostępna',
    Lock: 'Zablokuj',
    Unlock: 'Odblokuj',
    AddLayer: 'Dodaj element',
    LayerSectionTemplates: 'Szablony',
    LayerSectionText: 'Tekst i dane',
    LayerSectionImages: 'Obrazy',
    LayerSectionDecor: 'Dekoracja',
    LayerSectionTools: 'Narzędzia',
    DragLayersToReorder: 'Przeciągnij warstwy, aby zmienić kolejność',
    PleaseAgreeTOS: 'Zaakceptuj ogólne warunki, aby zatwierdzić swój projekt.',
    ErrorExportPrintFile: 'Wystąpił błąd podczas eksportu pliku do druku.',
    ErrorExportProofFile: 'Wystąpił błąd podczas eksportu wydruku próbnego.',
    ErrorAddToCart: 'Wystąpił błąd podczas dodawania do koszyka: ',
    Gabarit: 'Szablon',
    FicheTechnique: 'Karta techniczna',
    GeneratingPrintFile: 'Generowanie pliku do druku…',
    GeneratingProofFile: 'Generowanie wydruku próbnego…',
    LeaveCustomizer: 'Opuść konfigurator',
    LeaveManager: 'Opuść menedżera elementów',
    ChangeProductTitle: 'Twój projekt zostanie usunięty.',
    ChangeProductConfirm: 'Zmiana produktu trwale usunie Twój projekt, czy na pewno?',
    Duplicate: 'Duplikuj',
    LoadingTheme: 'Ładowanie motywu',
    LoadingPattern: 'Ładowanie tła',
    Expand: 'Powiększ',
    Shrink: 'Zmniejsz',
    TiltLeft: 'Przechyl w lewo',
    TiltRight: 'Przechyl w prawo',
    Rotate: 'Obróć',
    Move: 'Przesuń',
    Reposition: 'Zmień położenie',
    MoveUp: 'Przesuń w górę',
    MoveDown: 'Przesuń w dół',
    MoveLeft: 'Przesuń w lewo',
    MoveRight: 'Przesuń w prawo',
    NoCustomization: 'Na produkcie nie ma personalizacji.',
    MissingCustomization: 'Brak personalizacji',
    SelectGraduation: 'Wybierz gradient',
    ProofTitle: 'Wydruk próbny',
    ProofDesignTitle: 'Personalizacja 2D',
    ProofScreenshotsTitle: 'Widoki 3D',
    ProofSelectedInksTitle: 'Wybrane kolory',
    Warning: 'Uwaga',
    SelectZoneBeforeTheme: 'Wybierz strefę przed wyborem motywu.',
    ThemeTooManyElements: 'Motyw zawiera zbyt wiele elementów. Wybierz inny',
    Error: 'Błąd',
    ProductNotFound: 'Nie znaleziono produktu',
    ProductNotFoundMessage: 'Nie znaleziono produktu, nastąpi przekierowanie na stronę główną.',
    NoCategoryAvailable: 'Brak dostępnych kategorii',
    CategoryNotFound: 'Nie znaleziono kategorii',
    CategoryNotFoundMessage: 'Nie znaleziono kategorii, nastąpi przekierowanie na stronę główną.',
    Unavailable: 'Niedostępne',
    SavedConfigurations: 'Zapisane konfiguracje',
    YourSavedConfigurations: 'Twoje zapisane konfiguracje',
    NoSavedConfigurations: 'Brak zapisanych konfiguracji dla tego produktu',
    ConfigurationName: 'Nazwa konfiguracji',
    Created: 'Utworzono',
    Expires: 'Wygasa',
    Load: 'Wczytaj',
    ConfirmDeleteConfiguration: 'Czy na pewno chcesz usunąć tę konfigurację?',
    Close: 'Zamknij',
    Step: 'Krok',
    CustomizeProductDesc: 'Wybierz, jak zacząć: dowolne tworzenie lub na podstawie motywu proponowanego poniżej.',
    StartFromScratchDesc: 'Pusta kanwa do dodawania tekstów, obrazów i kształtów, bez narzuconego szablonu.',
    ChooseProductDesc: 'Wybierz produkt do personalizacji.',
    PrintMethod: 'Metoda druku',
    ChoosePrintMethod: 'Wybierz swoją metodę',
    ChoosePrintMethodDesc: 'Wybierz metodę druku dla tego produktu. Ten wybór jest ostateczny dla tej personalizacji.',
    Digital: 'Cyfrowy',
    ScreenPrinting: 'Sitodruk',
    LaserEngraving: 'Grawer laserowy',
    Embroidery: 'Haft',
    RestrictedToPalette: 'Kolory ograniczone do palety',
    ChooseInks: 'Wybierz swoje kolory',
    ChooseThreads: 'Wybierz swoje nici',
    AppliesToZone: 'Strefa: {zone}',
    Ink: 'Kolor',
    Thread: 'Nić',
    InkOverride: 'Wymuś kolor',
    ThreadOverride: 'Wymuś nić',
    SuggestInks: 'Sugerowane kolory',
    SuggestThreads: 'Sugerowane nici',
    RecommendColorsFromImage: 'Zaproponuj kolory na podstawie obrazu',
    NoColorSuggestion: 'Brak sugestii kolorów dla tego obrazu.',
    InkAssistantHelp: 'Ta metoda używa palety {count} stałych kolorów.',
    InkAssistantQuestion: 'Jak chcesz określić swoje kolory?',
    InkAssistantUpload: 'Pomóż mi znaleźć moje kolory',
    InkAssistantUploadDesc: 'Zaimportuj swój obraz, logo lub wzór – automatycznie wykryjemy najbliższe kolory palety.',
    InkAssistantManual: 'Wybieram kolory ręcznie',
    InkAssistantManualDesc: 'Wybierz każdy kolor po kolei z palety.',
    InkAssistantAnalyzing: 'Analiza obrazu…',
    InkChoiceModifiableHint: 'Ten wybór można zmienić w każdej chwili.',
    InkAssistantResultDesc: 'Oto kolory palety najbliższe Twojemu obrazowi.',
    InkDuplicateWarning:
        'Ten kolor jest już wybrany dla innego koloru / nici. Wybranie go po raz drugi trwale połączy kolory. Czy na pewno?',
    Selected: 'Wybrano',
    VectorizeImage: 'Wektoryzuj obraz',
    Vectorizing: 'Wektoryzacja…',
    VectorizePreviewTitle: 'Wynik wektoryzacji',
    VectorizeIntro:
        'Obraz zostanie przekształcony na wektor i ograniczony do wybranych kolorów. Zatwierdź wynik, aby go zastosować.',
    VectorizeApply: 'Zastosuj wektor',
    VectorizeConsent:
        'Rozumiem, że jestem odpowiedzialny za kontrolę wyniku wektoryzacji i że druk będzie jego odzwierciedleniem.',
    VectorizeThreshold: 'Próg (szczegół / tło)',
    VectorizeThresholdHint:
        'Dostosuj próg, aby doprecyzować: niższy usuwa więcej jasnego tła (line-art); wyższy zachowuje więcej jasnych obszarów.',
    VectorizeCancel: 'Anuluj',
    VectorizeFailed: 'Wektoryzacja nie powiodła się. Spróbuj ponownie lub zmień obraz.',
    Before: 'Przed',
    After: 'Po',
    VariableText: 'Tekst zmienny',
    VariableTextIntro:
        'Ta funkcja przypomina mailing i pozwala uzyskać produkt wydrukowany w jednym unikalnym egzemplarzu na każdy tekst; ilość jest automatycznie obliczana dla koszyka.',
    VariableTextData: 'Dane (jeden wiersz = jeden egzemplarz)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importuj CSV / Excel',
    SessionImages: 'Zaimportowane obrazy',
    Accept: 'Akceptuj',
    UploadConsentMessage:
        'Potwierdzam, że żaden z moich plików nie narusza obowiązujących przepisów, praw autorskich ani praw osób trzecich.',
    VariableTextNoData: 'Dodaj co najmniej jeden wiersz, aby zobaczyć podgląd.',
    VdpFields: 'Pola zmienne',
    VdpFieldName: 'Nazwa pola',
    VdpPlace: 'Umieść',
    VdpPlaced: 'Umieszczono',
    VdpAddField: 'Dodaj pole',
    VdpAddRow: 'Dodaj wiersz',
    VdpLine: 'Wiersz',
    VdpEnterData: 'Wprowadź moje dane',
    Done: 'Gotowe',
    VdpFieldStyle: 'Styl pola',
    VdpFirstRowHeader: '1. wiersz = nagłówek (nazwy pól)',
    VdpQuantity: 'Ilość: {qty}',
    VdpQuantityHint: 'Ilość jest narzucona przez liczbę wierszy tekstu zmiennego.',
    VariableTextOnlyOne: 'Tylko jedno pole tekstu zmiennego na projekt.',
    VariableTextEmptyFile: 'Pusty plik lub bez użytecznej kolumny.',
    VariableTextImportError: 'Nie można odczytać tego pliku. Użyj CSV lub wklej tekst.',
    VariableTextExcelUnavailable: 'Odczyt Excela niedostępny. Wyeksportuj do CSV lub wklej tekst.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks: 'Wybrane kolory: {chosen}/{required}. Wybierz wszystkie kolory przed zatwierdzeniem.',
    PreflightScreenColorCount: 'Sitodruk: Twój projekt jest ograniczony do {count} koloru/ów.',
    PreflightMinStroke: 'Zalecana minimalna grubość linii: {mm} mm. Cieńsze linie mogą źle się drukować.',
    PreflightMinFont: 'Zalecany minimalny rozmiar czcionki: {pt} pt.',
    PreflightLaserMonochrome: 'Grawer laserowy: efekt końcowy będzie monochromatyczny.',
    More: 'Więcej',
    All: 'Wszystkie',
    AllCategories: 'Wszystkie kategorie',
    SearchCategory: 'Szukaj kategorii…',
    NoProductAvailable: 'Brak produktów w tej kategorii.',
    ChooseProductTitle: 'Wybierz produkt do personalizacji',
    PrintMethodQuestion: 'Jak chcesz nadrukować swój {product}?',
    PrintMethodIntro:
        'Każda metoda ma swoje mocne strony i ograniczenia — określa dostępne później kolory i wykończenia.',
    StartLabel: 'Punkt wyjścia',
    StartTitle: 'Zacznij od motywu lub pustej strony',
    StartIntro: 'Motyw = gotowy projekt do dopracowania (najszybciej). Pusta strona = pełna kontrola.',
    StepProduct: 'Produkt',
    StepMethod: 'Metoda',
    StepStart: 'Start',
    StepDesign: 'Projekt',
    ChangeTheme: 'Zmień motyw',
    BackToTheme: 'Powrót do motywu',
    Recent: 'Ostatnie',
    WhiteNotPrintable: 'Biały nie może być drukowany (przezroczysty).',
    LoginToSave: 'Zaloguj się, aby znaleźć swoje projekty na koncie.',
    Login: 'Zaloguj się',
    LoggingIn: 'Logowanie…',
    ContinueWithoutAccount: 'Kontynuuj bez konta',
    SaveEmailPlaceholder: 'Twój adres e-mail',
    SaveEmailHint: 'Otrzymasz link do wznowienia projektu (przechowywany przez 30 dni).',
    SaveConfirmTitle: 'Projekt zapisany',
    SaveConfirmMessage: 'Twój projekt został zapisany. Właśnie wysłaliśmy Ci e-mail z linkiem do jego wznowienia.',
    DisableEmbroideryEffect: 'Wyłącz efekt haftu',
    AddThread: 'Dodaj nić',
    RemoveThread: 'Usuń nić',
    VectorizeDenoise: 'Redukuj szum',
    VectorizeDenoiseHint: 'Usuwa plamki i drobne niepożądane kropki.',
    VectorizeSmoothing: 'Wygładzanie',
    VectorizeSmoothingHint: 'Zaokrągla kontury (mniej narożników).',
    ZoomIn: 'Powiększ',
    ZoomOut: 'Pomniejsz',
    Fit: 'Dopasuj',
    Apply: 'Zastosuj',
    Edit: 'Edytuj',
    Support: 'Pomoc',
    VectorizeAcknowledge:
        'Rozumiem, że odpowiadam za sprawdzenie wyniku wektoryzacji i że nadruk będzie jego odzwierciedleniem.',
    Crop: 'Przytnij',
    Font: 'Czcionka',
    Style: 'Styl',
    Outline: 'Kontur',
    Steps: 'Kroki',
    Tools: 'Narzędzia',
    ThemeColors: 'Kolory',
    Minimize: 'Zminimalizuj',
    MoveLayerUp: 'Przenieś warstwę w górę',
    MoveLayerDown: 'Przenieś warstwę w dół',
    DragLayer: 'Przeciągnij, aby zmienić kolejność',
    NoResult: 'Brak wyników',
    SearchElement: 'Szukaj elementu…',
    ExpertMode: 'Tryb eksperta',
    Finish: 'Zakończ',
    ChooseImageOrPhoto: 'Wybierz obraz lub zdjęcie',
    WizardIntro: 'Wykonaj kolejne kroki, aby stworzyć spersonalizowany projekt w 1 minutę.',
    WizardIntroExpert: 'Chcesz więcej swobody? Przełącz się na tryb eksperta.',
    ClickToChooseImage: 'Kliknij tutaj, aby wybrać obraz lub zdjęcie',
    ChooseCategoryDesc: 'Wybierz rodzinę produktów, aby rozpocząć.',
    SelectProductDesc: 'Wybierz produkt, aby rozpocząć…',
    FinalReview: 'Ostatni krok',
    StartWithThemeDesc: 'Zacznij od gotowego projektu.',
    WithModelDesc: 'Wybierz gotowy szablon.',
    ExpertModeConfirmTitle: 'Tryb eksperta',
    ExpertModeConfirmMsg:
        'Przejście do trybu eksperta to decyzja ostateczna. Ten tryb jest nieco bardziej złożony w obsłudze, ale pozwala dodawać i edytować elementy bez ograniczeń.',
    ExpertModeHint: 'Dokończ swój projekt bez ograniczeń – dodawaj teksty i zdjęcia według uznania.',
    VariableData: 'Dane zmienne',
    PhotoFrame: 'Ramka na zdjęcie',
    PhotoFrameHint: 'Wybierz kształt, a następnie umieść w nim zdjęcie.',
    PhotoFrameChooseShape: '1. Kształt ramki',
    PhotoFrameChangeShape: 'Zmień kształt',
    PhotoFramePickPhoto: 'Wybierz zdjęcie',
    FromLibrary: 'Z biblioteki',
    VdpMaxRowsReached: 'Osiągnięto maksymalny stan magazynowy',
    VdpImportTruncated: 'Import ograniczony do dostępnego stanu magazynowego',
    LetterSpacing: 'Odstęp między literami',
    OutlineActive: 'Kontur włączony',
    OutlineThickness: 'Grubość konturu',
    AlignLeft: 'Wyrównaj do lewej',
    AlignCenter: 'Wyśrodkuj',
    AlignRight: 'Wyrównaj do prawej',
    Uppercase: 'Wielkie litery',
    TextFormatting: 'Formatowanie',
    FontSizeLabel: 'Rozmiar czcionki',
    SelectionActions: 'Akcje zaznaczenia',
    DragToMove: 'Przeciągnij, aby przesunąć',
    DragToResize: 'Przeciągnij, aby zmienić rozmiar',
    DragToRotate: 'Przeciągnij, aby obrócić',
    MoveUpOneLevel: 'Przenieś o poziom wyżej',
    MoveDownOneLevel: 'Przenieś o poziom niżej',
    BringToFront: 'Przenieś na wierzch',
    Front: 'Pierwszy plan',
    SendToBack: 'Przenieś na spód',
    BackgroundNeverUnderPattern: 'Tło (nigdy pod wzorem tła)',
    EyedropperColor: 'Pipeta koloru',
    PresetColors: 'Kolory predefiniowane',
    RecentColors: 'Ostatnie kolory',
    Palette: 'Paleta',
    HexValue: 'Wartość szesnastkowa',
    AiResultsHint: 'Wszystkie propozycje znajdziesz w zakładce Obraz',
    Notifications: 'Powiadomienia',
    Zoom: 'Powiększenie',
    GuidedCustomization: 'Personalizacja z przewodnikiem',
    Actions: 'Akcje',
    InkAssistantYourChoice: 'Wybrałeś:',
    InkAssistantCorrectQuestion: 'Czy chcesz zmienić ten wybór?',
    ZonePrices: 'Cena za strefę',
    ZonePriceApplied: 'Zastosowano',
    ZonePriceUncovered: 'Żadna opcja nie obejmuje wszystkich ozdobionych stref.',
    ZonePricesShow: 'Pokaż',
    ZonePricesHide: 'Ukryj',
    '': ''
};
